import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="survey-form"
export default class extends Controller {
    connect() {
        // Initialize the form
    }

    addQuestion(event) {
        event.preventDefault()

        const questionsContainer = this.element.querySelector('.survey-questions')
        const time = new Date().getTime()
        const newQuestionFieldset = document.createElement('div')
        newQuestionFieldset.className = 'nested-fields border border-slate-200 dark:border-slate-600 p-4 rounded-lg mb-4'
        newQuestionFieldset.dataset.newRecord = 'true'
        newQuestionFieldset.innerHTML = `
      <div class="flex justify-between items-center mb-2">
        <h6 class="text-sm font-semibold text-slate-900 dark:text-slate-200">New Question</h6>
        <button type="button" data-action="survey-form#removeQuestion" class="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5">
            <path fill-rule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <div class="grid grid-cols-1 gap-4 mb-4">
        <div>
          <label class="form-label" for="survey_survey_questions_attributes_${time}_question">Question Text</label>
          <input class="form-input" required="required" type="text" name="survey[survey_questions_attributes][${time}][question]" id="survey_survey_questions_attributes_${time}_question">
        </div>
        <div>
          <label class="form-label" for="survey_survey_questions_attributes_${time}_question_type">Question Type</label>
          <select class="form-input question-type-select" required="required" data-action="change->survey-form#toggleOptions" name="survey[survey_questions_attributes][${time}][question_type]" id="survey_survey_questions_attributes_${time}_question_type">
            <option value="">Select type</option>
            <option value="yes/no">Yes/No</option>
            <option value="rating">Rating</option>
            <option value="options">Options</option>
            <option value="text">Text</option>
          </select>
        </div>
        <div class="flex items-center">
          <input name="survey[survey_questions_attributes][${time}][is_required]" type="hidden" value="0">
          <input class="form-input-checkbox" type="checkbox" value="1" name="survey[survey_questions_attributes][${time}][is_required]" id="survey_survey_questions_attributes_${time}_is_required">
          <label class="form-label ml-2" for="survey_survey_questions_attributes_${time}_is_required">Required</label>
        </div>
        <div class="flex items-center">
          <input name="survey[survey_questions_attributes][${time}][is_active]" type="hidden" value="0">
          <input class="form-input-checkbox" type="checkbox" value="1" name="survey[survey_questions_attributes][${time}][is_active]" id="survey_survey_questions_attributes_${time}_is_active">
          <label class="form-label ml-2" for="survey_survey_questions_attributes_${time}_is_active">Active</label>
        </div>
      </div>

      <div class="options-container" data-survey-form-target="optionsContainer" style="display: none;">
        <h6 class="text-sm font-semibold text-slate-900 dark:text-slate-200 mb-2">Options</h6>

        <div data-survey-form-target="optionsTarget">
        </div>

        <div class="mt-2">
          <button type="button" data-action="survey-form#addOption" data-question-index="${time}" class="text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-sm flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-4 w-4 mr-1">
              <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
            </svg>
            Add Option
          </button>
        </div>
      </div>

      <input type="hidden" name="survey[survey_questions_attributes][${time}][_destroy]" id="survey_survey_questions_attributes_${time}__destroy" value="0">
    `

        questionsContainer.appendChild(newQuestionFieldset)
    }

    removeQuestion(event) {
        event.preventDefault()

        const item = event.target.closest(".nested-fields")

        // If it's a new record, remove it from the DOM
        if (item.dataset.newRecord) {
            item.remove()
        } else {
            // Otherwise, mark it for destruction
            const input = item.querySelector("input[name*='_destroy']")
            input.value = 1
            item.style.display = 'none'
        }
    }

    addOption(event) {
        event.preventDefault()

        const questionIndex = event.currentTarget.dataset.questionIndex
        const optionsContainer = event.target.closest(".options-container")
        const optionsTarget = optionsContainer.querySelector("[data-survey-form-target='optionsTarget']")
        const time = new Date().getTime()

        const newOptionFieldset = document.createElement('div')
        newOptionFieldset.className = 'nested-option-fields border border-slate-200 dark:border-slate-600 p-3 rounded-lg mb-2'
        newOptionFieldset.dataset.newRecord = 'true'
        newOptionFieldset.innerHTML = `
      <div class="flex justify-between items-center mb-2">
        <h6 class="text-xs font-semibold text-slate-900 dark:text-slate-200">New Option</h6>
        <button type="button" data-action="survey-form#removeOption" class="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-4 w-4">
            <path fill-rule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <div class="grid grid-cols-1 gap-2">
        <div>
          <label class="form-label text-sm" for="survey_survey_questions_attributes_${questionIndex}_survey_question_options_attributes_${time}_label">Option Label</label>
          <input class="form-input" required="required" type="text" name="survey[survey_questions_attributes][${questionIndex}][survey_question_options_attributes][${time}][label]" id="survey_survey_questions_attributes_${questionIndex}_survey_question_options_attributes_${time}_label">
        </div>
        <div>
          <label class="form-label text-sm" for="survey_survey_questions_attributes_${questionIndex}_survey_question_options_attributes_${time}_details">Details (Optional)</label>
          <textarea class="form-input" rows="2" name="survey[survey_questions_attributes][${questionIndex}][survey_question_options_attributes][${time}][details]" id="survey_survey_questions_attributes_${questionIndex}_survey_question_options_attributes_${time}_details"></textarea>
        </div>
        <input type="hidden" name="survey[survey_questions_attributes][${questionIndex}][survey_question_options_attributes][${time}][_destroy]" id="survey_survey_questions_attributes_${questionIndex}_survey_question_options_attributes_${time}__destroy" value="0">
      </div>
    `

        optionsTarget.appendChild(newOptionFieldset)
    }

    removeOption(event) {
        event.preventDefault()

        const item = event.target.closest(".nested-option-fields")

        // If it's a new record, remove it from the DOM
        if (item.dataset.newRecord) {
            item.remove()
        } else {
            // Otherwise, mark it for destruction
            const input = item.querySelector("input[name*='_destroy']")
            input.value = 1
            item.style.display = 'none'
        }
    }

    toggleOptions(event) {
        const questionType = event.target.value
        const optionsContainer = event.target.closest(".nested-fields").querySelector(".options-container")

        if (questionType === "options") {
            optionsContainer.style.display = "block"
        } else {
            optionsContainer.style.display = "none"
        }
    }
}
